import { createContext } from "react";

export const UpdateDeviceLabelContext = createContext(null);
